export const prStatusPermissions = {
  DRAFT: {
    view: { allowed: true },
    edit: { allowed: true },
    delete: { allowed: true },
    report: { allowed: false, message: 'Reports are only available after publishing the PR.' },
  },
  PENDING: {
    view: { allowed: true },
    edit: { allowed: false, message: 'Editing is disabled while your PR is under review. Contact support for urgent changes.' },
    delete: { allowed: false, message: 'This PR is currently being reviewed and cannot be deleted.' },
    report: { allowed: false, message: 'Reports are only available for published PRs.' },
  },
  OPEN: {
    view: { allowed: true },
    edit: { allowed: true },
    delete: { allowed: true },
    report: { allowed: false, message: 'Reports are only available for published PRs.' },
  },
  "ACTION REQUIRED": {
    view: { allowed: true },
    edit: { allowed: true },
    delete: { allowed: true },
    report: { allowed: false, message: 'Reports are only available for published PRs.' },
  },
  REJECT: {
    view: { allowed: true },
    edit: { allowed: false, message: 'This PR has been rejected and cannot be modified.' },
    delete: { allowed: false, message: 'Rejected PRs cannot be removed. Contact support for assistance.' },
    report: { allowed: false, message: 'Reports are only available for published PRs.' },
  },
  REJECTED: {
    view: { allowed: true },
    edit: { allowed: false, message: 'This PR has been rejected and cannot be modified.' },
    delete: { allowed: false, message: 'Rejected PRs cannot be removed. Contact support for assistance.' },
    report: { allowed: false, message: 'Reports are only available for published PRs.' },
  },
  PUBLISHED: {
    view: { allowed: true },
    edit: { allowed: false, message: 'Published PRs cannot be edited. Please contact support for modifications.' },
    delete: { allowed: false, message: 'This PR is already published and cannot be deleted.' },
    report: { allowed: true },
  },
  DELETED: {
    view: { allowed: true },
    edit: { allowed: false, message: 'This PR has been deleted and cannot be modified.' },
    delete: { allowed: false, message: 'This PR is already deleted.' },
    report: { allowed: false, message: 'Report is not available for deleted items.' },
  },
};

